import { blue, green, red, yellow, neutral, gray } from './colors';
import { primaryFont, fontWeight, typeScale, Baloo } from './typography';

export const webViewtheme = {
  colors: {
    primary: {
      default: red[200],
      hover: neutral[100],
      active: red[100],
      textColor: neutral[100],
    },
    secondary: {
      default: red[200],
      hover: neutral[100],
      active: red[100],
      textColor: neutral[100],
    },
    tertiary: {
      default: neutral[600],
      hover: neutral[200],
      active: neutral[300],
      textColor: neutral[600],
    },
  },
  primaryColor: red[200],
  primaryHoverColor: neutral[100],
  primaryActiveColor: red[200],
  primaryBackground: red[100],
  secondaryColor: red[300],
  tertiaryColor: red[300],

  textColorOnPrimary: neutral[100],
  primaryBackgroundColor: red[100],
  textColor: neutral[600],
  textColorInverted: neutral[100],
  primaryFont: primaryFont,
  tertiaryHoverColor: neutral[200],
  textHoverColor: neutral[200],
  primaryFontWeight: fontWeight['primary'],
  disabled: neutral[200],
  textOnDisabled: neutral[400],
  textFieldBackground: neutral[200],
  textFieldLabelColor: neutral[500],
  labelColor: neutral[600],
  lightBullet: gray[400],
  labelBackgroundColor: neutral[200],
  primaryBorder: neutral[300],
  primaryBorderActive: blue[200],
  border: neutral[200],
  backgroundLight: neutral[150],
  background: neutral[100],
  shadow: gray[100],
  lightGreen: green[100],
  status: {
    warningColor: yellow[200],
    warningColorHover: yellow[300],
    save: blue[100],
    cancel: gray[200],
    warningColorActive: yellow[200],
    errorColor: red[200],
    errorColorHover: red[300],
    errorColorActive: red[300],
    successColor: green[200],
    successColorHover: green[300],
    successColorActive: green[300],
  },
  text: {
    default: neutral[600],
    inactive: neutral[200],
    bodyText: neutral[300],
    bodyTextLight: neutral[400],
    bodyTextDark: neutral[500],
    iconLabel: gray[300],
    primary: red[200],
    white: neutral[100],
    warning: yellow[200],
    error: red[200],
    success: green[200],
  },
  typeScale,
  fontWeight,
  fontFamily: Baloo,
};
